import React, { useEffect } from "react";
import "../Common/Styles/Dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import RevenueOverViewReport from "./Reports/RevenueOverViewReport";
import { getMainDashboardData } from "../../redux/settings/action";
import dashboard1 from "../assets/images/dashboard-1.png";
import dashboard2 from "../assets/images/dashboard-2.png";
import Riyal from "../assets/images/Saudi_Riyal.png";
import dashboard3 from "../assets/images/dashboard-3.png";
import UserActivityChart from "./Reports/UserActivityChart";
import InvoiceDashboard from "./Reports/InvoiceDashboard";
import UserRegistration from "./Reports/UserRegistration";
import DashboardMembershipChart from "./Reports/DashboardMembershipChart";
import MembershipChargeTimeline from "./Reports/MembershipChargeTimeline";
import FullScreenLoader from "../Layouts/FullScreenLoader/FullScreenLoader";

export default function Dashboard() {
  const dispatch = useDispatch();

  const rawDashboard = useSelector((state) => state?.reusableSlice?.getdashboard);
  const dashboard =
    rawDashboard && !Array.isArray(rawDashboard) ? rawDashboard : null;
  const userSourceSummary = dashboard?.user_source_summary || {};
  const phase2Summary = dashboard?.phase2_summary || {};
  const activeMembershipSummary = dashboard?.active_membership_summary || {};
  const activeMembershipBuckets = activeMembershipSummary?.buckets || {};
  const membershipChargeTimeline = dashboard?.membership_charge_timeline || {};

  useEffect(() => {
    dispatch(getMainDashboardData({}));
  }, [dispatch]);

  const displayValue = (value) => value ?? 0;
  const formatSar = (value) =>
    Number(value || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const compactDate = (value) => {
    if (!value) return "--";
    return String(value).split(" ")[0];
  };

  const DashboardCard = ({ title, icon, children, className = "col-md-6" }) => (
    <div className={`${className} d-flex flex-column mb-3`}>
      <div className="first-sec h-100">
        <div className="total-invoice dashboard-content h-100">
          <h4>
            {title} <img src={icon} alt="" />
          </h4>
          {children}
        </div>
      </div>
    </div>
  );

  const DashboardPanel = ({ children, className = "col-md-6" }) => (
    <div className={`${className} d-flex flex-column mb-3`}>{children}</div>
  );

  const ActiveMembershipPanel = () => {
    const monthlyMyfatoorah = activeMembershipBuckets?.monthly_myfatoorah || {};
    const monthlyShopify = activeMembershipBuckets?.monthly_shopify || {};
    const semiAnnualMyfatoorah = activeMembershipBuckets?.semi_annual_myfatoorah || {};
    const annualShopify = activeMembershipBuckets?.annual_shopify || {};

    return (
      <>
        <p>
          Monthly MyFatoorah <span>{displayValue(monthlyMyfatoorah.count)}</span>
        </p>
        <p>
          Monthly Shopify <span>{displayValue(monthlyShopify.count)}</span>
        </p>
        <p>
          Semi-Annual MyFatoorah <span>{displayValue(semiAnnualMyfatoorah.count)}</span>
        </p>
        <p>
          Annual Shopify <span>{displayValue(annualShopify.count)}</span>
        </p>
        <p>
          Total active <span>{displayValue(activeMembershipSummary?.total_active)}</span>
        </p>
        <p>
          Current plan value SAR <span>{formatSar(activeMembershipSummary?.total_paid_sar)}</span>
        </p>
        <p>
          Monthly equivalent SAR{" "}
          <span>{formatSar(activeMembershipSummary?.monthly_revenue_sar)}</span>
        </p>
      </>
    );
  };

  const RecentRowsPanel = ({ title, rows, renderPrimary, renderMeta }) => (
    <div className="upcoming-book h-100">
      <div className="d-flex justify-content-between align-items-center upcoming-head pad-head">
        <h6>{title}</h6>
      </div>
      <div className="d-flex justify-content-between align-items-center employeesec">
        <div className="carousel-sec dashboard-recent-list">
          {rows?.length > 0 ? (
            rows.map((row, index) => (
              <div className="dashboardimg dashboard-recent-row" key={`${title}-${index}`}>
                <h6>
                  <span className="dashboard-recent-main">{renderPrimary(row)}</span>
                  <span className="dashboard-recent-meta">{renderMeta(row)}</span>
                </h6>
              </div>
            ))
          ) : (
            <div className="dashboard-empty-state">No records found</div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="dashboard-name">
      {!dashboard ? (
        <FullScreenLoader />
      ) : (
        <div className="">
          {/* <h2 className="">My Dashboard</h2> */}
          <div className="row dashboard-row align-items-stretch">
            <DashboardCard title="All-Time Purchases" icon={dashboard2} className="col-md-3">
              <p>
                Membership Charges{" "}
                <span>{displayValue(dashboard?.membership_summary?.total_membership)}</span>
              </p>
              <p>
                Add-Ons{" "}
                <span>{displayValue(dashboard?.membership_summary?.total_addon)}</span>
              </p>
              <p>
                Free-Trials{" "}
                <span>{displayValue(dashboard?.membership_summary?.total_free_trial)}</span>
              </p>
              <p>
                Total Revenue{" "}
                <span>
                  <img
                    src={Riyal}
                    alt="SAR"
                    style={{ height: "15px", width: "15px" }}
                  />{" "}
                  {formatSar(dashboard?.membership_summary?.total_price)}
                </span>
              </p>
            </DashboardCard>

            <DashboardCard title="Active Memberships" icon={dashboard2} className="col-md-3">
              <ActiveMembershipPanel />
            </DashboardCard>

            <DashboardPanel>
              <RecentRowsPanel
                title="Recent Membership Charges"
                rows={dashboard?.recent_purchases || []}
                renderPrimary={(row) => row.customer_name}
                renderMeta={(row) => (
                  <>
                    <span className="dashboard-recent-meta-line">
                      {row.payment_provider_label || row.source_label || "Unknown"} /{" "}
                      {row.term_label} / {row.plan_title || "Membership"}
                    </span>
                    <span className="dashboard-recent-meta-line">
                      SAR {formatSar(row.amount_sar)}
                    </span>
                  </>
                )}
              />
            </DashboardPanel>

            <DashboardCard title="Users" icon={dashboard1} className="col-md-3">
              <p>
                Customers <span>{displayValue(userSourceSummary?.total_customers)}</span>
              </p>
              <p>
                Shopify Users <span>{displayValue(userSourceSummary?.shopify_users)}</span>
              </p>
              <p>
                WordPress Users <span>{displayValue(userSourceSummary?.wordpress_users)}</span>
              </p>
              <p>
                Website Users <span>{displayValue(userSourceSummary?.website_users)}</span>
              </p>
            </DashboardCard>

            <DashboardPanel>
              <UserRegistration user={dashboard}></UserRegistration>
            </DashboardPanel>

            <DashboardCard title="Invoice" icon={dashboard1} className="col-md-3">
              <p>
                Simplified <span>{displayValue(dashboard?.invoice_data?.invoice_count)}</span>
              </p>
              <p>
                VAT <span>{displayValue(dashboard?.invoice_data?.invoice_count1)}</span>
              </p>
              <p>
                Purchase <span>{displayValue(dashboard?.invoice_data?.invoice_count2)}</span>
              </p>
              <p>
                Credit <span>{displayValue(dashboard?.invoice_data?.invoice_count3)}</span>
              </p>
              <p>
                Debit <span>{displayValue(dashboard?.invoice_data?.invoice_count4)}</span>
              </p>
              <p>
                Total Invoices
                <span>{displayValue(dashboard?.invoice_data?.total_invoice_count)}</span>
              </p>
              <p>
                Invoices - Last 30 Days
                <span>{displayValue(dashboard?.invoice_data?.last_30_days_invoice_count)}</span>
              </p>
            </DashboardCard>

            <DashboardPanel>
              <InvoiceDashboard
                title="Users with Most Invoices - Last 30 Days"
                users={dashboard?.user_invoice_count_30_days || []}
              />
            </DashboardPanel>

            <DashboardPanel>
              <InvoiceDashboard
                title="Users with Most Invoices - All Time"
                users={dashboard?.user_invoice_count || []}
              />
            </DashboardPanel>

            <DashboardPanel>
              <RecentRowsPanel
                title="Recently Activated Phase 2"
                rows={dashboard?.recent_phase2_activations || []}
                renderPrimary={(row) => row.customer_name}
                renderMeta={(row) =>
                  `${compactDate(row.activated_on)}${row.source_label ? ` / ${row.source_label}` : ""}`
                }
              />
            </DashboardPanel>

            <DashboardCard title="Phase 2" icon={dashboard3}>
              <p>
                Integrated <span>{displayValue(phase2Summary?.integrated)}</span>
              </p>
              <p>
                Not Integrated <span>{displayValue(phase2Summary?.not_integrated)}</span>
              </p>
            </DashboardCard>

            <DashboardPanel>
              <div className="upcoming-book h-100">
                <h4>Invoices Created - Last 10 Days</h4>
                <UserActivityChart
                  users_activity={dashboard.user_activity || []}
                ></UserActivityChart>
              </div>
            </DashboardPanel>

            <DashboardPanel className="col-md-6">
              <RevenueOverViewReport data={dashboard?.revenue_overview || []} />
            </DashboardPanel>

            <DashboardPanel className="col-md-6">
              <MembershipChargeTimeline
                title="Monthly Revenue"
                periodLabel="Last 30 Days Charges"
                data={membershipChargeTimeline?.monthly_last_30_days || []}
                daily
              />
            </DashboardPanel>

            <DashboardPanel className="col-md-6">
              <MembershipChargeTimeline
                title="Yearly Revenue"
                periodLabel="Last 12 Months Charges"
                data={membershipChargeTimeline?.long_term_last_12_months || []}
              />
            </DashboardPanel>

            <DashboardPanel className="col-md-6">
              <DashboardMembershipChart
                membersInfo={activeMembershipSummary?.by_plan || []}
              />
            </DashboardPanel>
          </div>
        </div>
      )}
    </div>
  );
}
